import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HasPermissionPipe } from '@overflo1/frame-frontend';
import { AlmaboxPermissions } from 'src/app/almabox.permissions';
import projectVersionJson from '../../../../../project-version.json';
import {MatListModule} from '@angular/material/list';
import { AsyncPipe } from '@angular/common';
import { FrameMenuComponent } from '@overflo1/frame-frontend';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [
    HasPermissionPipe,
    AsyncPipe,
    MatIconModule,
    MatListModule,
    FrameMenuComponent,
    RouterLink,
    RouterLinkActive,
  ],
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [
    HasPermissionPipe,
    AsyncPipe,
  ]
})
export class MenuComponent implements OnInit {

  readonly AlmaboxPermissions = AlmaboxPermissions;
  frontendVersion?: string;
  machineMenuExpanded = false;

  constructor(
    private router: Router,
  ) {
    this.frontendVersion = projectVersionJson.version;
  }

  ngOnInit(): void {
    this.machineMenuExpanded = this.router.url.startsWith('/frame/entity/machine');
  }

  toggleMachineMenu(): void {
    this.machineMenuExpanded = !this.machineMenuExpanded;
  }
}
